import React, { Component } from 'react';
import classNames from 'classnames';

class TextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: ''
    };
  }

  render() {
    const {
      helperText,
      className,
      errorMsg,
      labelText,
      labelClassName,
      inputClassName,
      helperTextClassName,
      htmlFor,
      autoComplete,
      ...rest
    } = this.props;

    const wrapperClasses = classNames('txt-field ', className, {
      'txt-field--disabled': this.props.disabled
    });

    return <div className={wrapperClasses}>
      <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      <input id={htmlFor} {...rest} autoComplete={autoComplete} className={classNames(inputClassName, { [inputClassName + '--error']: errorMsg })} />
      { helperText && <div data-test-id={`${this.props?.["data-test-id"]}-helper-text`} className={classNames('txt-field-helper-msg', helperTextClassName)}>{helperText}</div> }
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

TextField.defaultProps = {
  inputClassName: 'txt-field-input',
  autoComplete: 'disabled'
};

export default TextField;

